import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wpcm-product-info" }
const _hoisted_2 = { class: "wpcm-product-details" }
const _hoisted_3 = { class: "wpcm-product-item" }
const _hoisted_4 = { class: "wpcm-value" }
const _hoisted_5 = { class: "wpcm-product-item" }
const _hoisted_6 = { class: "wpcm-value" }
const _hoisted_7 = { class: "wpcm-product-item wpcm-total" }
const _hoisted_8 = { class: "wpcm-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("h3", null, "Product Donation Info", -1 /* HOISTED */)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "wpcm-label" }, "Item Price:", -1 /* HOISTED */)),
        _createElementVNode("span", _hoisted_4, _toDisplayString($setup.getSymbol()) + _toDisplayString($setup.getItemPrice()), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "wpcm-label" }, "Quantity:", -1 /* HOISTED */)),
        _createElementVNode("span", _hoisted_6, _toDisplayString($setup.getQuantityText()), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "wpcm-label" }, "Total Amount:", -1 /* HOISTED */)),
        _createElementVNode("span", _hoisted_8, _toDisplayString($setup.getSymbol()) + _toDisplayString($setup.getConvertedTotal()), 1 /* TEXT */)
      ])
    ])
  ]))
}